import { IAddressEntity } from "models/Address.model";
import { base64Decode } from "utils/base64Decode";
import get from "lodash/get";
import toInteger from "lodash/toInteger";
import { ApplicationStatus } from "./ApplicationStatus.model";

export enum AccessRequestStatus {
  Pending = "PENDING",
  Approved = "APPROVED",
  Denied = "DENIED",
  Expired = "EXPIRED",
}

export type IAccessRequest = {
  incomingAccessRequests: IAccessRequestEntity[];
  myAccessRequests: IAccessRequestEntity[];
};

export type IAccessRequestEntity = {
  requestGuid: string;
  applicationId: number;
  applicationNumber: string;
  applicationStatus: ApplicationStatus;
  consentNumber: string;
  status: AccessRequestStatus;
  requestUser?: {
    email: string;
    firstName: string;
    lastName: string;
    countryCode: string;
    phoneNumber: string;
    organisation: string;
    address: IAddressEntity;
  };
  address: string;
  createdDate: string;
  completionDate: string;
  expireTime: string;
};

export type IAccessRequestApplicantFormData = {
  applicationNumber: string;
  authorityId: number;
};

export type IAccessRequestParams = {
  applicationId: number;
};

export const AccessRequestUtil = {
  base64Decode: (encodedString: string): IAccessRequestParams => {
    const decodedString = decodeURIComponent(base64Decode(encodedString));
    const json = JSON.parse(decodedString);
    const data = {
      applicationId: toInteger(get(json, "applicationId")),
    };

    return data;
  },
};

export const AccessRequestStatusUtil = {
  parse: (str: string): AccessRequestStatus => {
    for (const value of Object.values(AccessRequestStatus)) {
      if (str.toLowerCase() === value.toString().toLowerCase()) {
        return value;
      }
    }
    return AccessRequestStatus.Pending;
  },
};
